module.exports = __webpack_public_path__ + "static/media/vehicles-icon.94c6467a.svg";